import React from "react"
import PropTypes from "prop-types"
import { Modal } from "react-bootstrap"
import { browserHistory } from 'react-router'

import Button from "./Button"

/**
 *
 */

const SimpleModal = ({ show, children, title, onClose, _id }) => (
  <Modal show={show} onHide={() => onClose()}>
    <Modal.Header><Modal.Title>Detalles: {title}</Modal.Title></Modal.Header>
    <Modal.Body>
      {children}
    </Modal.Body>
    <Modal.Footer>
      <Button
        onClick={() => { browserHistory.push(`/private/activity/${encodeURIComponent(_id)}?`) }}
        glyph="link"
      >
        Ir a página de la actividad
      </Button>
      <Button onClick={() => onClose()}>Cerrar</Button>
    </Modal.Footer>
  </Modal>
)

SimpleModal.propTypes = {
  _id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
}

SimpleModal.defaultProps = {
  show: true
}

export default SimpleModal
